import Statistics from '../components/Statistics'
import StatsTable from '../components/StatsTable'


const Dashboard = () => {
 

  return (
    <div>
      <Statistics />
      <StatsTable />
    </div>
  )
}

export default Dashboard
